import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";

const principles = [
  { icon: "ri-focus-3-line", title: "体验优先", desc: "翻页流畅、加载迅速、目录清晰,把阅读体验放在第一位。" },
  { icon: "ri-heart-line", title: "尊重创作", desc: "尊重每一位创作者的心血,坚持正版授权与合法传播。" },
  { icon: "ri-eye-line", title: "贴心护眼", desc: "夜间模式与柔和配色,让长时间阅读也能轻松舒适。" },
  { icon: "ri-shield-check-line", title: "数据可靠", desc: "阅读记录自动同步,进度不丢失,畅享无缝追更。" },
];

const values = [
  { icon: "ri-compass-line", title: "我们的定位", desc: "策驰漫画网是一个面向中文漫画读者的在线阅读平台,汇集热门国漫与优质作品,让好故事更触手可及。" },
  { icon: "ri-lightbulb-line", title: "发展理念", desc: "我们相信,好的阅读体验离不开流畅的翻页、便捷的目录和可靠的记录同步。技术为内容服务,一切为了让你更好地看完每一部作品。" },
  { icon: "ri-bookmark-line", title: "内容原则", desc: "坚持内容真实、更新及时、分类清晰,拒绝注水与虚假推荐,让你每一次打开都能快速找到想看的漫画。" },
];

const testimonials = [
  { name: "苏苏", text: "用了很久的漫画网站,翻页和目录都很顺手,夜间模式真的太贴心了。" },
  { name: "大风", text: "阅读记录同步功能很靠谱,手机看一半,晚上电脑接着看,进度一点不差。" },
  { name: "锦鲤", text: "收藏追更很方便,喜欢的作品更新了马上就能看到,体验很满意。" },
];

export default function About() {
  return (
    <Layout>
      <div className="mx-auto max-w-5xl px-4 py-8 md:px-6">
        <nav aria-label="面包屑" className="flex flex-wrap items-center gap-1 text-sm text-foreground-500">
          <a href="/" className="hover:text-primary-600">首页</a>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-700">关于我们</span>
        </nav>

        {/* Hero intro */}
        <header className="mt-6 rounded-2xl bg-primary-700 px-6 py-12 text-center md:py-16">
          <h1 className="font-heading text-3xl text-background-50 md:text-4xl">关于策驰漫画网</h1>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-background-100/90 md:text-base">
            策驰漫画网致力于打造流畅、护眼、值得信赖的中文漫画在线阅读平台。我们相信,一部好漫画值得被舒舒服服地读完。
          </p>
        </header>

        {/* Positioning / values */}
        <section className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3">
          {values.map((v) => (
            <div key={v.title} className="rounded-xl border border-background-200/80 bg-background-50 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-100 text-accent-600 dark:bg-secondary-100">
                <i className={`text-xl ${v.icon}`}></i>
              </span>
              <h2 className="mt-4 text-lg font-bold text-foreground-950">{v.title}</h2>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{v.desc}</p>
            </div>
          ))}
        </section>

        {/* Principles */}
        <section className="mt-10 bg-background-100">
          <div className="rounded-2xl px-5 py-10">
            <h2 className="text-center font-heading text-2xl text-foreground-950 md:text-3xl">我们的内容原则</h2>
            <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              {principles.map((p) => (
                <div key={p.title} className="rounded-xl border border-background-200/80 bg-background-50 p-5 text-center">
                  <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-700 dark:bg-secondary-100">
                    <i className={`text-xl ${p.icon}`}></i>
                  </span>
                  <h3 className="mt-3 font-bold text-foreground-950">{p.title}</h3>
                  <p className="mt-2 text-sm leading-6 text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="mt-10">
          <h2 className="text-center font-heading text-2xl text-foreground-950 md:text-3xl">用户口碑</h2>
          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-xl border border-background-200/80 bg-background-50 p-5">
                <div className="flex gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-6 text-foreground-700">“{t.text}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-600 font-heading text-background-50">{t.name[0]}</span>
                  <span className="text-sm font-bold text-foreground-950">{t.name}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </section>

        {/* Contact */}
        <section className="mt-10 rounded-2xl border border-background-200/80 bg-background-50 p-6">
          <h2 className="font-heading text-xl text-foreground-950">联系方式</h2>
          <p className="mt-2 text-sm leading-6 text-foreground-600">
            对网站有任何建议、反馈或合作意向,欢迎通过以下方式联系我们,我们会尽快回复。
          </p>
          <div className="mt-4 flex flex-col gap-3 text-sm text-foreground-700 sm:flex-row sm:gap-8">
            <p className="flex items-center gap-2">
              <i className="ri-mail-line text-accent-600"></i>
              service@cechicomic.example
            </p>
            <p className="flex items-center gap-2">
              <i className="ri-wechat-line text-accent-600"></i>
              微信公众号:策驰漫画网
            </p>
            <Link to="/faq" className="flex items-center gap-2 text-primary-600 hover:text-primary-700">
              <i className="ri-question-line"></i>
              常见问题
            </Link>
          </div>
        </section>
      </div>

      {/* AboutPage schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "关于策驰漫画网",
            description:
              "策驰漫画网是专注中文漫画在线阅读的平台,提供流畅翻页、目录跳转、收藏追更、阅读记录同步与夜间护眼模式。",
          }),
        }}
      />
    </Layout>
  );
}